import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validates that two form fields contain the same value.
 * @param fieldName - Primary field name
 * @param confirmFieldName - Confirmation field name
 * @param errorName - Error key to set on mismatch
 * @returns Validator function for the form group
 */
export function confirmField(
  fieldName: string,
  confirmFieldName: string,
  errorName: string = 'passwordMismatch'
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const field = control.get(fieldName);
    const confirmFieldControl = control.get(confirmFieldName);

    if (!field || !confirmFieldControl) {
      return null;
    }

    if (confirmFieldControl.errors && !confirmFieldControl.errors[errorName]) {
      return null;
    }

    if (field.value !== confirmFieldControl.value) {
      confirmFieldControl.setErrors({ [errorName]: true });
      return { [errorName]: true };
    }

    if (confirmFieldControl.errors?.[errorName]) {
      delete confirmFieldControl.errors[errorName];
      if (Object.keys(confirmFieldControl.errors).length === 0) {
        confirmFieldControl.setErrors(null);
      }
    }

    return null;
  };
}
